import { Component, computed, inject, LOCALE_ID, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BasketService } from '@basket';
import {
  DocumentPathService,
  JourneyStepTrackerService,
  JourneyType,
  StickyDirective,
} from '@common';

import {
  BenefitsListAdditionalItemsComponent,
  BenefitsListCoveredItemsComponent,
  BenefitsListNotCoveredItemsComponent,
  ButtonComponent,
  GridColumnComponent,
  GridContainerComponent,
  GridRowComponent,
  LegalInfoPanelComponent,
  LinkComponent,
  ProgressionStepsComponent,
  TrustboxComponent,
} from '@components';
import { CoverDetailsService } from '@data-access';
import {
  LocaleId,
  provideTranslationDictionaryMapping,
  TranslatePipe,
  TranslateService,
} from '@i18n';
import { PosthogTrackingEvents } from '@tracking';
import posthog from 'posthog-js';
import { SelectedAppliancesComponent } from '../../components/selected-appliances/selected-appliances.component';
import { FeatureMultiPlanTranslationDictionary } from '../../i18n/feature-multi-plan-dictionary.interface';
import { translation } from '../../i18n/translation.constant';
import { MultiPlanService } from '../../services/multi-plan/multi-plan.service';

@Component({
  selector: 'app-review-cover',
  imports: [
    BenefitsListAdditionalItemsComponent,
    BenefitsListCoveredItemsComponent,
    BenefitsListNotCoveredItemsComponent,
    ButtonComponent,
    GridColumnComponent,
    GridContainerComponent,
    GridRowComponent,
    LegalInfoPanelComponent,
    LinkComponent,
    ProgressionStepsComponent,
    SelectedAppliancesComponent,
    StickyDirective,
    TranslatePipe,
    TrustboxComponent,
  ],
  templateUrl: './review-cover.component.html',
  styleUrl: './review-cover.component.scss',
  providers: [provideTranslationDictionaryMapping(translation)],
})
export class ReviewCoverComponent implements OnInit {
  private readonly basketService = inject(BasketService);
  private readonly documentPathService = inject(DocumentPathService);
  private readonly journeyStepTracker = inject(JourneyStepTrackerService);
  private readonly localeId = inject<LocaleId>(LOCALE_ID);
  private readonly multiPlanService = inject(MultiPlanService);
  private readonly router = inject(Router);
  private readonly coverDetailsService = inject(CoverDetailsService);
  private readonly translateService = inject(
    TranslateService<FeatureMultiPlanTranslationDictionary>,
  );
  formSubmitted = false;

  readonly localeIdIsGB = computed(
    () => this.localeId === LocaleId.English_GreatBritain,
  );

  readonly isMultiPlanJourney = this.basketService.isMultiPlanJourney;
  readonly selectedAppliances = this.multiPlanService.selectedAppliances;
  readonly coveredItems = this.coverDetailsService.getCoveredItems;
  readonly notCoveredItems = this.coverDetailsService.getNotCoveredItems;
  readonly additionalItems = this.coverDetailsService.getAdditionalItems;

  ngOnInit(): void {
    this.journeyStepTracker.updateStep(
      2,
      3,
      this.translateService.translate('STEP_TITLE_REVIEW_COVER'),
      false,
    );

    if (!this.multiPlanService.selectedAppliancesDetails().length) {
      this.documentPathService.setJourneyType(JourneyType.ApplianceCare);
    }
    posthog.capture(PosthogTrackingEvents.MultiPlanReviewCoverPageLoaded);
  }

  continueClicked() {
    this.formSubmitted = true;
    this.router.navigate(['contact-details']);
  }

  onChangeApplianceDetailsClick() {
    posthog.capture(
      PosthogTrackingEvents.MultiPlanReviewCoverChangeApplianceDetails,
    );
  }

  onChangeAppliancesClick() {
    posthog.capture(PosthogTrackingEvents.MultiPlanReviewCoverChangeAppliances);
  }
}
